import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "../dev-logging/DevLoggingContext";
import { usePlatformResource } from "./PlatformResourceHook";
// Set the default state values for each context
const PlatformResourceContext = /*#__PURE__*/createContext({});
export const PlatformResourceContextProvider = ({
  children,
  resourceList,
  applicationName,
  defaultContentMap,
  delayResourcesAPICall,
  previousLocale
}) => {
  const hook = usePlatformResource(resourceList, applicationName, defaultContentMap, delayResourcesAPICall, previousLocale);
  const {
    stateTracker
  } = useDevLogging();
  const resourceContext = useMemo(() => {
    stateTracker.trackState({
      resources: {
        ...hook.resources,
        resourceList
      }
    });
    return {
      ...hook
    };
  }, [hook.resources]);
  return /*#__PURE__*/React.createElement(PlatformResourceContext.Provider, {
    value: resourceContext
  }, children);
};
export const useResources = () => {
  return useContext(PlatformResourceContext);
};
PlatformResourceContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  resourceList: PropTypes.array.isRequired,
  applicationName: PropTypes.string.isRequired,
  defaultContentMap: PropTypes.object,
  delayResourcesAPICall: PropTypes.bool,
  previousLocale: PropTypes.string
};